import { Collapse } from "@mui/material";
import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { AuthAPIGateway } from "../../api/auth";
import ModalErrorBase from "../../components/ModalErrorBase";
import Content from "../../components/layout/Content";
import ContentHeader from "../../components/layout/ContentHeader";
import { useAuth } from "../../context/AuthContext";
import { formatPhone } from "../../utils/formatPhone";
import CompanyInfoStep from "./components/CompanyInfoStep";
import NameStep from "./components/NameStep";
import ResumeStep from "./components/ResumeStep";
import SuccessStep from "./components/SuccessStep";

function CreateAccount(props) {
  document.title = "Criar conta | NotePay";

  const navigate = useNavigate();

  const { setLoading } = useAuth();

  const [creationError, setCreationError] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();

  const fromReactNative = (searchParams.get("fromReactNative") || "") === "1";
  const step = searchParams.get("step") || "0";

  const name = searchParams.get("name") || "";
  const lastname = searchParams.get("lastname") || "";
  const companyName = searchParams.get("companyName") || "";
  const country = searchParams.get("country") || "BR";
  const currency = searchParams.get("currency") || "BRL";
  const language = searchParams.get("language") || "PT";
  const phone = searchParams.get("phone") || "";
  const usersNum = searchParams.get("usersNum") || "";
  const erp = searchParams.get("erp") || "";
  const leadOrigin = searchParams.get("leadOrigin") || "";
  const email = searchParams.get("email") || "";

  const handleGoBackLogin = () => {
    navigate(`/`, {
      replace: true,
    });
  };

  const nextStep = () => {
    searchParams.set("step", (parseInt(step) + 1).toString());
    setSearchParams(searchParams);
  };
  const prevStep = () => {
    searchParams.set("step", (parseInt(step) - 1).toString());
    setSearchParams(searchParams, { replace: true });
  };

  const handleSubmitName = (name, lastname, email) => {
    searchParams.set("name", name);
    searchParams.set("lastname", lastname);
    searchParams.set("email", email);
    setSearchParams(searchParams);
    nextStep();
  };

  const handleSubmitCompanyInfo = (data) => {
    Object.keys(data).forEach((field) => {
      searchParams.set(field, data[field]);
    });
    setSearchParams(searchParams);
    nextStep();
  };

  //CREATE ACCOUNT

  const handleCreateAccount = async () => {
    setLoading(true);
    try {
      const { data } = await AuthAPIGateway.createAccount({
        email,
        companyName,
        currency,
        lastname,
        name,
        erp,
        phone: formatPhone(phone),
        usersNum,
        leadOrigin,
      });
      searchParams.set("step", "3");
      setSearchParams(searchParams);
    } catch (error) {
      setCreationError(
        error?.response?.data?.message?.toString() ||
          "Oops, erro inesperado ao solicitar conta. Por favor, tente novamente."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Content>
        <Collapse unmountOnExit in={step === "0"}>
          <ContentHeader
            title="Cadastrar sua empresa na NotePay"
            subtitle="Vamos começar com o seu nome e e-mail."
          />
          <NameStep
            initialLastname={lastname}
            initialName={name}
            onSubmit={handleSubmitName}
            onPrev={handleGoBackLogin}
            fromReactNative={fromReactNative}
          />
        </Collapse>
        <Collapse unmountOnExit in={step === "1"}>
          <ContentHeader
            title={`Olá, ${name}.`}
            subtitle="Insira algumas informações sobre a sua empresa."
          />
          <CompanyInfoStep
            onPrev={prevStep}
            onSubmit={handleSubmitCompanyInfo}
            initialValues={{
              language,
              country,
              currency,
              usersNum,
              erp,
              companyName,
              phone,
            }}
          />
        </Collapse>
        <Collapse in={step === "2"}>
          <ResumeStep
            onPrev={prevStep}
            onCreate={handleCreateAccount}
            {...{
              name,
              lastname,
              email,
              erp,
              companyName,
              currency,
              country,
              language,
            }}
          />
        </Collapse>
        <Collapse timeout={0} unmountOnExit in={step === "3"}>
          <SuccessStep
            name={name}
            email={email}
            fromReactNative={fromReactNative}
          />
        </Collapse>
      </Content>
      <ModalErrorBase
        open={Boolean(creationError)}
        title={"Erro ao criar conta"}
        subtitle={creationError}
        onClose={() => setCreationError(null)}
      />
    </>
  );
}

export default CreateAccount;
